var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconManagePoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "01) Icons/Filled/star-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4884 24.5008C20.3041 24.5008 20.1186 24.4576 19.9483 24.3689L13.9994 21.2609L8.05177 24.3689C7.65744 24.5731 7.18144 24.5381 6.82444 24.2768C6.4651 24.0154 6.2866 23.5733 6.36244 23.1358L7.49527 16.5698L2.6886 11.9206C2.36894 11.6114 2.25344 11.1471 2.38994 10.7224C2.52644 10.3001 2.8916 9.99093 3.3326 9.92793L9.9826 8.96193L12.9553 2.9816C13.3496 2.18826 14.6504 2.18826 15.0448 2.9816L18.0174 8.96193L24.6674 9.92793C25.1084 9.99093 25.4736 10.3001 25.6101 10.7224C25.7466 11.1471 25.6311 11.6114 25.3114 11.9206L20.5048 16.5698L21.6376 23.1358C21.7134 23.5733 21.5338 24.0154 21.1756 24.2768C20.9726 24.4261 20.7311 24.5008 20.4884 24.5008Z",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_655_4160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4884 24.5008C20.3041 24.5008 20.1186 24.4576 19.9483 24.3689L13.9994 21.2609L8.05177 24.3689C7.65744 24.5731 7.18144 24.5381 6.82444 24.2768C6.4651 24.0154 6.2866 23.5733 6.36244 23.1358L7.49527 16.5698L2.6886 11.9206C2.36894 11.6114 2.25344 11.1471 2.38994 10.7224C2.52644 10.3001 2.8916 9.99093 3.3326 9.92793L9.9826 8.96193L12.9553 2.9816C13.3496 2.18826 14.6504 2.18826 15.0448 2.9816L18.0174 8.96193L24.6674 9.92793C25.1084 9.99093 25.4736 10.3001 25.6101 10.7224C25.7466 11.1471 25.6311 11.6114 25.3114 11.9206L20.5048 16.5698L21.6376 23.1358C21.7134 23.5733 21.5338 24.0154 21.1756 24.2768C20.9726 24.4261 20.7311 24.5008 20.4884 24.5008Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_655_4160)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagePoints);
export default __webpack_public_path__ + "static/media/iconManagePoints.df4f0fb900b79e7b3e666d8989705381.svg";
export { ForwardRef as ReactComponent };